const activities = {
    cantina_tilli: {
        name: 'Azienda Tilli',
        subtitle: 'Wijnproeverij en Typische Producten',
        description: 'Bezoek de Azienda Tilli voor een proeverij van lokale wijnen en typische producten uit Abruzzo. Een authentieke ervaring om de traditionele smaken van de regio te ontdekken.',
        duration: '2-3 uur',
        difficulty: 'Beginner',
        season: 'Het hele jaar',
        price: '€25-45',
        locations: [
            'Scanno',
            'Villetta Barrea'
        ],
        requirements: [
            'Minimumleeftijd: 18 jaar voor wijnproeverij',
            'Reservering verplicht',
            'Casual kleding'
        ],
        included: [
            'Wijnproeverij',
            'Lokale typische producten',
            'Rondleiding door de wijnkelder',
            'Verzekering'
        ],
        highlights: [
            'Kwaliteitswijnen uit de regio',
            'Typische Abruzzo producten',
            'Bezoek aan historische wijnkelder',
            'Authentieke ervaring',
            'Mogelijkheid tot aankoop'
        ]
    },
    arrosticini_mucciante: {
        name: 'Arrosticini bij Mucciante',
        subtitle: 'Authentieke Abruzzo Culinaire Traditie',
        description: 'Beleef de authentieke smaak van Abruzzo arrosticini in het historische Mucciante restaurant. Een traditionele culinaire ervaring die je de meest authentieke smaken van de regio laat kennen.',
        duration: '1-2 uur',
        difficulty: 'Beginner',
        season: 'Het hele jaar',
        price: '€15-25',
        locations: [
            'Mucciante',
            'Rocca Calascio gebied'
        ],
        requirements: [
            'Reservering aanbevolen',
            'Casual kleding'
        ],
        included: [
            'Traditionele arrosticini',
            'Lokale wijn',
            'Traditionele bijgerechten',
            'Authentieke sfeer'
        ],
        highlights: [
            'Historisch restaurant',
            'Traditionele bereiding',
            'Authentieke Abruzzo smaken',
            'Combinatie met lokale wijn',
            'Culturele ervaring'
        ]
    },
    sextantio: {
        name: 'Overnachting in Hotel Sextantio',
        subtitle: 'Het Verspreide Hotel van het Dorp',
        description: 'Verblijf in het unieke Hotel Sextantio, een verspreid hotel dat de authentieke architectuur van Santo Stefano di Sessanio bewaart. Een onvergetelijke ervaring ondergedompeld in geschiedenis en traditie.',
        duration: 'Overnachting',
        difficulty: 'Beginner',
        season: 'Het hele jaar',
        price: '€150-300 per nacht',
        locations: [
            'Santo Stefano di Sessanio'
        ],
        requirements: [
            'Reservering verplicht',
            'Geldig identiteitsbewijs'
        ],
        included: [
            'Overnachting',
            'Traditioneel ontbijt',
            'Historische kamer',
            'Hoteldiensten'
        ],
        highlights: [
            'Historische architectuur',
            'Authentieke sfeer',
            'Traditioneel ontbijt',
            'Unieke ervaring',
            'Locatie in het dorp'
        ]
    },
    wild_life_spotting: {
        name: 'Wildlife',
        subtitle: 'Ontdek de wilde natuur van Abruzzo',
        description: 'Op ontdekking naar herten en wolven',
        duration: '2 uur',
        difficulty: 'Gemakkelijk'
    }
};

export default activities;

